import { createFileRoute } from '@tanstack/react-router';

/** The Coach layout draws the conversation (`CoachMain` in coach-page.tsx), so a fresh one named here keeps what it drew on `/coach`. */
function DrawnByLayout(): null {
  return null;
}

/** One conversation, open or reopened from the server (board 11-coach-thread). */
export const Route = createFileRoute('/_app/coach/$threadId')({ component: DrawnByLayout });
